module.exports = {
  language: {
    name: '中文',
    current: '当前语言',
  },
  common: {
    uploadExImg:'上传展会图片',
    uploadExVideo:'上传展会视频',
    sendImg: '发送图片',
    tip: '提示',
    submit: '提交',
    required1: '带',
    required2: '为必填项',
    importantremind: '重要提醒',
    explain: '说明',
    suggest1: '建议您在',
    suggest2: '前完成资料的填写及上传。',
    suggest3: '产品资料愈丰富，曝光机会愈多。',
    placeholder: '请输入',
    select: '请选择',
    forshow: '用于企业页面展示',
    uploadimg1: '格式：{format}; 建议尺寸：{recomsize}px; 大小：{filesize}内',
    uploadimg2: '建议上传图片大小为：{recomsize}px',
    uploadimg3: '最多上传6条，上传第一张为封面图',
    uploadfile: '大小：单个文件20M内；最多上传6条',
    uploadvideo: '格式：{format}; 大小：{filesize}内，只能上传一个文件，重复上传会替换视频',
    jumpUrl: '点此前往展商信息页面查看视频效果~',
    uploadvideo2: '格式：{format}; 大小：{filesize}内，只能上传一个文件',
    tishi: '申请截止时间:{time}',
    selectfile: '选择文件',
    inputarea1: '字数：还可输入',
    inputarea2: '字符，最多可输入{Num}个字符（含标点及空格）',
    tinymce1: '字数:还可以输入',
    tinymce2: '个字符，不少于20字符，最多可输入',
    tinymce3: '个字符（含标点及空格）',
    sort: '*默认排序为0，序号越大排序越前',
    operate: '操作',
    preview: '预览',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    add: '添加',
    pagination: '共{totalNum}条数据',
    Number: '序号',
    order: '排序',
    publish: '发布',
    status: '状态',
    statusall: '全部',
    auditstatus: '审核通过 | 审核不通过 | 审核中',
    auditstatus2: '审核中 | 已通过 | 未通过',
    auditoptions: '审核中 | 已通过审核 | 未通过审核',
    saveAudit: '已保存未申请提交审核',
    startdate: '开始时间',
    enddate: '结束时间',
    num: {
      one: '1',
      two: '2',
      three: '3',
      four: '4',
      five: '5',
      six: '6',
      seven: '7',
      eight: '8',
      nine: '9',
      ten: '10',
      eleven: '11',
      twelve: '12',
      thirteen: '13',
      fourteen: '14',
    },
    tips: '提示：仅支持上传H.264编码的视频，请在转码时注意导出设置，并在上传后检查是否可以正常播放。',
    reEdit: '重新编辑',
    share: '分享',
    imgView: '图片看展',
    videoView: '视频看展',
    uploadImg: '上传展会照片',
    uploadVideo: '上传展会视频',
    received: '收到的名片',
    invite: '诚邀您莅临参观',
    scan: '扫描二维码进行观众预登记',
    visit: '展会现场可凭身份证进馆参观',

  },
  //登录页面
  viewDetail: {
    title: '第二十届中国国际煤炭采矿技术交流及设备展览会',
    theme: 'China Coal & Mining Expo 2023',
    time: '北京中国国际展览中心（新馆） 2023年10月25-28日',
    home: '首页',
    exhibition: '展商',
    exhibits: '展品',
    live: '直播',
    activity: '活动',
    onlineHall: '线上展厅',
    VRview: 'VR看展',
    imgView: '图片看展',
    videoView: '视频看展',
    onlineWeb: '展会官网',
    audienceLogin: '观众登录',
    exhibitionLogin: '展商登录',
    viewEffect: '预览效果',
    detailTitle: '展品详情',
    productModel: '产品型号：',
    prosuctSeries: '产品系列：',
    productCategory: '产品类别：',
    collectExhibition: '收藏展商',
    productIntroduce: '展品介绍',
    productParameter: '展品参数',
    productTravelBrochure: '展品宣传资料',
    infoName: '宣传资料名称',
    other: '其他展品',
    consult: '咨询展商',
    more: '了解更多',
    en: 'English',
    zh: 'Chinese',
  },
  logo: {
    title: '北京中国国际展览中心（新馆） | 2023年10月25-28日',
    denglu: '欢迎登录',
    quit: '返回首页',
    biaoti: '中国国际采矿展线上展会展商个人中心',
    placeholder: '请输入账号',
    placeholder1: '请输入密码',
    tiaokuan1: '我已经阅读并同意',
    tiaokuan2: '展商系统用户须知及免责条款。',
    submit: '登录',
    noAccount: '没有账号?',
    canzhan: '参展申请',
    tiaokuan3: ' 用户名和密码由展会组委会提供，如有任何疑问可以致电展会组 委会，',
    mianze: {
      mianzeTitle: '展商系统 – 系统用户须知&免责条款',
      mianzeContent:
        '本网站承诺保护您的个人隐私。您无需提供任何个人信息就可以访问我们站点的大多数网页。不过,有时候,我们的确需要某些信息才能为您提供您请求的服务,本隐私权声明解释了这些情况下的数据收集和使用情况。本隐私权声明仅适用于本网站。',
      account: '系统用户须知',
      mianze1: '系统用户应确保在本系统中所上传或填写的信息（包括公司介绍等）真实有效，相关宣传内容应符合相关法律法规（包括但不限于广告法、反不正当竞争法等）。',
      mianze2:
        '系统用户应确保向中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司提供的数据真实有效，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司可以为了提供本系统服务内容而将该信息转交给第三方，也可以为实现其商业目的而处理和使用系统用户提供的数据；但前提是前述使用应遵守数据保护的相关法律。系统用户确认并承诺其向中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司提供的相关数据的来源合法，且其对该等数据的使用已取得相关数据主体的授权同意',
      mianze3: '系统用户应确保所上传的资料（包括文字、logo，图片等）均不侵犯任何第三方知识产权及其他合法权利，包括但不限于商标权、著作权、专利权及肖像权等。',
      mianze4:
        '系统用户如对上述有任何违反，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司有权修改、删除相关内容或停止向展商提供服务，系统用户应对该违反情况承担全部责任，并赔偿中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司因此造成的一切损失（包括但不限于对第三方的赔偿、罚款等）。',
      mianze6: '免责声明',
      mianze7: '本系统内容由展商提供，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司不对内容的正确性、完整性和最新状态承担任何责任。',
      mianze8:
        '本系统中包含第三方外部网站的链接，我们无法控制这些网站的内容。在任何情况下，相关网站提供者或运营者须对链接网站的内容负责，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司不对此承担任何责任。',
      mianze9:
        '中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司特别保留权利更改或扩展本系统所提供内容，恕不另行通知。您基于由本系统或经本系统提供的信息作出决定，须自行承担风险。中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司不对因使用由本系统或经本系统提供的信息造成的任何直接或间接损失承担赔偿责任。',
      mianze10:
        '对任何因直接或间接使用本系统内容而造成的任何损失，包括但不限于因有关内容有错误、遗漏、病毒等而导致的损失，中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司不对此承担任何法律责任。',
      mianze11:
        '本系统中有关展商的信息、图片、logo等均由相应展商提供，不得擅自下载或使用。如您有异议，请联中国煤炭工业国际技术咨询有限责任公司及汇显展览有限公司。',
    },

    dialglog: {
      diaglogMess: '登录失败,请勾选条款!',
      logSuccess: '恭喜你,登陆成功!',
      logceil: '登录失败,账号或密码错误!',
      notNull: '用户名或密码不能为空!',
      rules1: '请输入用户名',
      rules2: '请输入密码',
    },
  },
  //侧边导航
  navbar: {
    hall: '易展厅',
    home: '首页',
    exhibitor: '展商信息',
    product: '产品中心',
    active: '展商活动',
    live: '展商直播',
    news: '展商新闻',
    publicize: '宣传资料',
    message: '我的消息',
    service: '展商服务',
    specal: '特装申报',
    lintel: '标摊门楣',
    catalogue: '会刊信息',
    green: '家具/绿植',
    card: '参展商证',
    invite: '观众邀请',
    padfInite: 'PDF邀请',
    wx: '微信邀请',
    email: '邮件邀请',
    group: '团体邀请',
    download: '下载中心',
    connection: '联系我们',
    password: '修改密码',
    surelogout: '你确定退出登录？',
    sure: '确 定',
    cancel: '取 消',
    logout: '注销',
  },
  //首页
  homepage: {
    viewall: '查看全部',
    exhibitor: '展商信息',
    editexhibitor: '编辑信息',
    pavilion: '展馆',
    positionNumber: '展位号',
    boothType: '展位类型',
    boothArea: '展位面积',
    statistics: '数据统计',
    completeness: '信息完善度',
    productnum: '已发布产品数',
    activenum: '已发布现场活动',
    livenum: '已上传直播活动',
    audiencenum: '已预约观众',
    product: '产品中心',
    addproduct: '新增产品',
    nonproduct: '您尚未添加任何产品，暂无产品信息',
    news: '展商新闻',
    addnews: '新增新闻',
    nonnews: '您尚未添加新闻，暂无新闻资讯',
    active: '展商活动',
    addactive: '新增活动',
    nonactive: '您尚未添加活动，暂无活动信息',
    live: '展商直播',
    addlive: '新增直播',
    live_suggest: '展商直播发布预告经组委会审核通过后，将在展会官方网站进行发布，将有利于扩大直播影响范围。',
    nonlive: '您尚未添加直播，暂无直播信息',
    message: '我的消息',
    addmessage: '咨询展商',
    nonmessage: '暂无信息数据',
  },
  //展商信息
  exhiInformat: {
    exhibitor: '展商信息',
    companytab: '公司信息',
    boothtab: '展位信息',
    remind1:
      '通过该平台提交的所有资料将用于您的线上宣传，也会在展会微信公众号、官网等主办方的宣传中使用，不包括展会会刊。在参展商不做出特别声明的情况下，展会主办方有权使用参展商通过本平台所发布的文字、照片、视频、企业Logo等信息，用于第19届中国国际采矿展宣传使用。为助力您聚集线上关注、提升展前宣传、获得更好的参展效果和线上商机，请务必完整、准确填写！所上传或填写的公司、产品等相关宣传内容请务必注意符合广告法等相关法律法规，避免出现不合规的表述。',
    date: '2023年08月30日',
    cnname: '公司名称·中文',
    enname: '公司名称·英文',
    type: '企业类型',
    connection: '以上信息如需更改请联系展会组委会',
    address: '公司地址：',
    postCode: '邮编：',
    telephone: '公司电话：',
    url: '公司网址：',
    cnlogo: '公司Logo·中文：',
    enlogo: '公司Logo·英文：',
    cnintroduction: '公司介绍·中文：',
    enintroduction: '公司介绍·英文：',
    videoCover: '企业宣传视频封面：',
    uploadvideocn: '上传视频·中文：',
    uploadvideoen: '上传视频·英文：',
    uploadwx: '上传公司微信公众号二维码：',
    pavilion: '展馆',
    positionNumber: '展位号',
    boothType: '展台类型',
    boothArea: '展位面积',
    boothheight: '展台限高',
    boothimg: '展位图',
    bootheffect: '展台效果图',
    affiliatedExhib: '所属展区',
    email: '邮箱',
  },
  //产品中心
  product: {
    Number: '序号',
    productimg: '产品图片',
    nameCn: '产品名称-中文',
    nameEn: '产品名称-英文',
    classification: '产品分类',
    series: '产品系列',
    addproduct: '新增产品',
    editproduct: '编辑产品',
    date: '2023年8月30日',
    type: '产品型号',
    class: '产品类型',
    Keywords: '产品关键字',
    first: '一级分类',
    second: '二级分类',
    third: '三级分类',
    customclass: '产品自定义类型',
    maintain: '维护产品系列',
    remarks: '备注：点击“删除”按钮，该系列下展品不会被删除，但产品中心页面将不再有该系列出现。',
    warnInfo: '可鼠标拖动添加好的序列进行排序，靠前的权限最高',
    customclassname: '产品系列名称',
    customplaceholder: '请输入内容',
    viewcustom: '查看示例',
    remarks2: '由参展商进行自定义产品的系列或分类名称，并对产品进行自定义分类。',
    picture: '展品图片',
    data: '上传产品资料',
    cnintroduce: '展品介绍·中文',
    enintroduce: '展品介绍·英文',
    cnparameter: '展品参数·中文',
    enparameter: '展品参数·英文',
    videocover: '展品宣传视频封面',
    video: '上传产品视频',

    //维护产品系列内容
    allProduct: '全部产品',
    chengtao: '成套设备',
    shusong: '输送设备',
    zhihu: '支护设备',
    caimei: '采煤机',
    juemiao: '掘锚设备',
    quanzid: '全自动刨煤机',
    zuanji: '钻机',
    dianji: '电机',
    categroy: '井下开采',
    categroy1: '井下掘进',
    categroy2: '煤矿机电与动力',
    productName: 'EBH300A岩石掘进机',
    procuctName1: '大功率重型刮板输送机',
    productName2: '薄煤层支架',
    productName3: '交流电牵引采煤机',
    productName4: 'TK-3型地质钻机',

    rules: {
      message1: '展品图片不能为空',
      message2: '展品介绍·中文不能为空!',
      message3: '展品介绍·中文字数超出限制',
      message4: '展品介绍·英文字数超出限制',
      message5: '展品参数-中文字数超出限制',
      message6: '展品参数-英文字数超出限制',

      tishi1: '产品名称不能为空',
      tishi2: '产品自定义类型不能为空',
      tishi3: '产品类型不能为空',
      tishi4: '请选择展品图片',

      tishi5: '产品资料大小不能超过20MB',

      tishi6: '请上传正确的视频格式',
      tishi9: '视频大小不能超过100MB',
      tishi7: '上传文件只能是 jpg,png,gif格式!',
      tishi8: '上传文件大小不能超过2MB!',
      tishi10: '请检查填写的数据!',
      tishi11: '编辑产品错误,请重新编辑!',
      tishi12: '添加产品错误,请重新添加!',
    },
  },
  //展商活动
  active: {
    activecover: '活动封面图片',
    name: '活动名称',
    type: '活动分类',
    location: '活动地点',
    tips: '活动信息如需更改请联系展会组委会：010-64212207，参展商发布的活动组委会审核通过后将在展会网站进行展示',
    editactive: '编辑活动',
    tishi: '申请截至：',
    date: '2023年10月20日',
    activeType: '活动类型',
    technology: '技术交流会',
    productLanuch: '产品发布会',
    boothActiv: '展台活动',
    other: '其他',
    cnActiveName: '活动名称·中文',
    enActiveName: '活动名称·英文',
    placeholder: '请输入活动名称',
    placeholder1: '请输入活动地点',
    selectDate: '选择日期',
    activeAddress: '活动地点',
    activePhote: '活动图片',
    activeIntroCh: '活动简介·中文',
    activeIntroEn: '活动简介·英文',
    noPass: ' 审核未通过,请重新填写信息后再提交',
    cause: '未通过原因',
    inreview: '审核中',
    approve: '审核通过',
    hint: '活动已提交主办方审核，请注意关注审核结果',
    submit: '提交',
  },
  //展商直播
  live: {
    Livecover: '直播封面图片',
    liveName: '直播名称',
    liveType: '直播类型',
    liveEdit: '直播编辑',
    tishi: '邀请截止时间',
    liveDate: '2023年9月30日',

    liveNameCh: '直播名称·中文',
    placeholder: '请输入直播名称',
    liveNameEn: '直播名称·英文',
    uploadimg1: '上传直播封面图片',
    vedioType: '视频类型',
    uploadvideo: '上传视频',
    liveLink: '直播外链',
    liveQcrod: '直播入口二维码',
    placeholder1: '请输入直播链接地址',
    liveIntroCh: '直播简介·中文',
    liveIntroEn: '直播简介·英文',
    liveRules: {
      tishi1: '直播开始时间不能为空',
      tishi2: '直播简介·中文不能为空!',
      tishi3: '直播封面不能为空',
      tishi4: '视频内容不能为空',
      tishi5: '视频地址不能为空',
      tishi6: '二维码图片不能为空',
      tishi7: '视频外链请以"http"或"https://"开头!',
      tishi8: '请输入直播名称·中文',
      tishi9: '请选择开始时间',
      tishi10: '请选择视频类型',
      tishi11: '请输入直播简介·中文',
      tishi12: '请选择视频封面',
    },
  },
  //展商新闻
  news: {
    coverPhoto: '封面图片',
    newsTitle: '直播标题',
    abstract: '摘要',
    issueDate: '发布日期',
    editNews: '编辑新闻',
    newsNameCh: '新闻标题·中文',
    placeholder1: '请输入新闻标题',
    zhaoyai: '摘要·中文',
    newsContent: '新闻内容·中文',
  },
  //宣传资料
  publicity: {
    tishi: '至多上传6项资料',
    tishi2: '文件大小：100M内',
    uploadData: '上传资料',
    dataName: '文件名称',
    language: '语言',
    size: '大小',
    editDate: '编辑资料',
    chinese: '中文',
    English: '英文',
    dataUsername: '资料名称',
    placeholder: '请输入资料名称',
    information: '资料文件',
    clickUpload: '点击上传',
  },
  //我的消息
  minMessage: {
    addresser: '发件人',
    company: '公司',
    department: '部门/职务',
    sendTime: '发送时间',
    look: '查看',
    send: '发送',
  },

  //特装申请
  special: {
    specialApply: '特装申请',
    exhiName: '展商名称',
    linkman: '联系人',
    iphone: '手机',
    telephone: '电话',
    placeholder: '请选择展台类型',
    //搭建商信息
    exhibProduc: '搭建商信息',
    exProName: '搭建商名称',
    exProAddress: '搭建商地址',
    exprolinman: '联系人',
    exproIphone: '手机',
    exproTelephone: '电话',

    //展台信息
    boothInfor: '展台信息',
    boothHeight: '展台高度',
    boothtier: '展台层数',
    onetier: '一层',
    twitier: '二层',
    boothPoint: '展台吊点',

    //展台照明用电
    boothIllum: '展台照明用电',
    number: '序号',
    serviceProject: '服务项目',
    quantity: '数量',
    placeholderNum: '请输入数量',
    locate: '处',
    booth: {
      project1: '15A/220V',
      project2: '20A/220V',
      project3: '30A/220V',
      project4: '40A/220V',
      project5: '50A/220V',
      project6: '60A/220V',
      project7: '80A/220V',
      project8: '100A/220V',
      project9: '120A/220V',
    },

    //展台用水

    boothWater: '展台用水',
    bootWaterProj1: '300L/Min',
    bootWaterProj2: '600L/Min',
    bootWaterProj3: '1000L/Min',
    bootWaterProj4: '生活用水',
    //展台动力用电
    boothPower: '展台动力用电',
    powerProject: {
      project1: '施工临时用电15A/220V',
      project2: '施工临时用电30A/220V',
      project3: '15A/220V/24hr（单相)',
      project4: '30A/220V/24hr（三相）',
      project5: '15A/220V（单相）',
      project6: '30A/380V（三相）',
      project7: '60A/380V（三相）',
      project8: '100A/380V（三相）',
      project9: '150A/380V（单相）',
      project10: '200A/380V（三相）',
      project11: '300A/380V（三相）',
      project12: '400A/380V（三相）',
    },

    uploadimg1: '上传展台效果图',
    uploadimg2: '上传展台平面图',
    uploadimg3: '上传展台立面图',

    tishi1: '展台效果图不能为空,请重新选择!',
    tishi2: '展台平面图不能为空,请重新选择!',
    tishi3: '展台立面图不能为空,请重新选择!',
    //表单校验提示信息
    rules: {
      exhProName: '请输入活动名称',
      comAddress: '搭建商地址不能为空',
      linkman: '联系人不能为空',
      cellphone: '手号码不能为空',
      cellphone2: '手机号最少为11位数',
      email: 'E-mail邮箱不能为空',
      email2: '请输入正确的邮箱地址',
    },
    //图片校验
    rulesBooth: {
      tishi0: '请输入展台高度',
      tishi1: '请选择展品效果图',
      tishi2: '请选择展台平面图',
      tishi3: '请选择展台立面图',
    },
  },

  //标准门楣
  lintel: {
    explain1: '1、标摊门楣信息只适用于标准展位的参展商填写；',
    explain2: '2、每个标准展位上只能显示一家参展商名称；',
    explain3: '3、门楣信息须同合同所使用的展商名称一致，展商须保证提供名称的正确性。',
    living: '门楣实例',
    companyName: '公司名称',
    uniteNameCh: '单位名称·中文',
    uniteNameEn: '单位名称·英文',
    rulesMessage: '单位名称不能为空',
    placeholder1: '首字母大写、其余小写',
    tishi: '如果对展商中文名称或者展位号有疑义可以致电展会组委会',
    iphone: '010-84293556',
  },
  //会刊信息
  catalogue: {
    explain1: '1、参展展品介绍将免费为参展企业刊登在展会会刊上，请尽量言简意赅；',
    explain2: '2、此表为参展设备技术介绍，不涉及企业品牌宣传；',
    explain3: '3、参展商如若在会刊上刊登更多信息，可付费选择会刊广告或企业logo；',
    explain4: '4、会刊展品介绍内容展商提供，展商须保证所提供内容准确性和完整性；',
    explain5: '5、逾期未提交本表单，组委会不承诺能够在本届展会会刊刊登贵司展品信息。',
    explain6: '6、会刊信息审核通过后，如需更改请联系展会组委会：马洁010-64222205',
    companyTishi: '公司名称不能为空',
    placeholder: '请输入公司英文名称',
    placeholder1: '请输入公司中文地址',
    placeholder2: '请输入公司英文地址',
    placeholder3: '请输入公司邮编',
    placeholder4: '请输入公司联系电话',
    placeholder5: '请输入公司邮箱',
    placeholder6: '请输入公司网址',
    companyAddress: '公司地址·中文',
    companyAddressEn: '公司地址·英文',
    open: '展开',
    down: '收起',
    telephone: '电话',
    address: '网址',
    hint: '字数：还可以输入',
    hint2: '字符,最多可以输入{number}字符(含标点以及空格)',
    exhibClass: '展品分类目录',
    hint3: '请将贵司参展展品所属分类选中，如未包括请在“其他未注明”予以说明',
    other: '其他产品类别',
    modifi: '修改',
    time: '2023年8月31日',
    rules: {
      emial: '邮箱格式不合规，请重新输入',
      email_null: '邮箱不能为空',
      companyNameC: '公司名称·中文不能为空',
      column14: '公司名称·英文不能为空',
      column15: '公司地址·中文不能为空',
      column16: '公司地址·英文不能为空',
      telephone: '电话不能为空',
      introduceC: '展品介绍·中文不能为空',
      introduceE: '展品介绍·英文不能为空',
    },
  },
  //家具绿植租赁
  Furniture: {
    exhi: '展具租赁',
    gennRent: '绿植租赁',
    title: '展具及绿植租赁',
    date: '申请截止时间：2023年10月20日',
    shuoming: '说明：',
    smContent: '本届展会的家具和绿植租赁由北京中展商务服务有限公司提供，详细服务信息请参考下图',
    iphone: '服务电话',
    xianchang: '展期现场服务点电话',
    zhanguan: 'W馆 010-80468229、E馆 010-80468230',
    tele: '手机 13691586795、13811600271、13552931289',
    jiandu: '服务监督电话 010-80468237 / 80468249',
    email: '邮箱 sfcs@ciec.com.cn',
    serviceTime: '服务时间',
    buzhan: '布展期 9:00-17:00',
    buzhanEnd: '布展最后一天 9:00-21:00',
    startKai: '开展期 9:00-17:00',
    serviceAddre: '服务地点',
    bangong: 'W1-W2 / E1-E2卸货区租赁办公点',
    bangong2: 'W3-W4 / E3-E4卸货区临增办公点',
    bangong3: '临增租赁服务点视展会大小开放',
    bangong4: '免费配送、维护、回收、发票开具',
    selectNumb: '选择租用展位：',
    titleRent: '总租金',
    Furint: {
      select: '已选中',
      ge: '把', // piece of Furniture
      zhuijia: '把展具',
      picture: '图片',
      serial: '编号',
      special: '规格',
      number: '数量',
      mine: '我租赁的展具',
      exhiName: '展品名称',
      zero: '零租',
      rentNum: '租用数量',
      exhinumb: '展位号',
      states: '状态',
      title: '请确认本次展具租赁清单',
      count: '小计',
      operate: '操作',
      desk: '桌子',
      chair: '椅子',
      eletrirc: '电器',
      other: '其他',
      sofa: '沙发',
      biaotan: '标摊用品',
      setMea: '套装',
      tea: '茶几',
      dialglog: '请选择则租用展位',
      dialglog1: '提交失败请选择租赁得展具',
    },

    //展具绿植
    GeenPlat: {
      plant: '盆绿植',
      lvzhi: '盆',
      lvzhi1: '绿植',
      title: '我租赁的花卉绿植',
      pinghua: '瓶花',
      hua2: '花卉',
    },
  },

  //参展商证
  card: {
    explain: '1、如需要更多参展商证件，请联系展会组委会，咨询电话',
    explaincnnect: '王涛 010-84293538 邮箱:chinaminexpo@vip.163.com',
    explain1: '2、根据疫情防控要求，所有进入展馆的参展商须进行实名登记，凭身份证进出展馆。请参展商如实填写现场参展人员信息。',
    explain3: ' 3、展会组委会所收集参展商信息仅用于本届展会现场进出馆使用，不用于其他用途。',
    allocation: '分配标准',
    standard: '标准展位',
    showDard: '展位',
    remark: '备注',
    area: '{area}㎡',
    num: '{num}个',
    shuoming1: '4个/24平方米(每满6平方米1个)',
    shuoming2: '最多不超过80个',
    shuoming3: '按照展位面积分配参展证数量，最多不超过80个。超过规定数量，每个需缴纳工本费：20元/个,',
    shuoming4: '展会现场增加证件费用为：40元/个',
    contestant: '参展人员信息',
    addContestant: '新增参展人员',
    name: '姓名',
    cardType: '证件类型',
    idcard: '证件号码',
    unitName: '单位名称',
    unitAddress: '单位地址',
    IDnumber: '证件号码',

    duty: '职务',
    iphone: '手机',
    email: '邮箱',
    state: '状态',
    pass: '已通过',
    noPass: '未通过',
    under: '审核中',
    tishi1: '如设贵公司参展人员较多，请',
    tishi2: '点击此处下载人员名单模板',
    uploadFile: '上传文件',
    tishi3: '请选择要提交审核的参展人员信息再进行提交',
    addContest: '新增参展人员信息',
    editContest: '编辑参展人员信息',

    placeholder: '请输入姓名',
    placeholder1: '请输入单位名称',

    placeholder2: '请输入证件类型',
    placeholder3: '请输入证件号码',
    placeholder4: '请选择展位号',
    placeholder5: '请输入展位号',
    placeholder6: '请输入职务',
    placeholder7: '请输入手机号',
    placeholder8: '请输入单位地址',
    placeholder9: '请输入E-mail',

    tishi4: '参展人员等级窗口已经关闭',
    tishi5: '如变更参展人员信息请致电展会组委会',
    tishi6: '超出分配数量',
    tishi7: '请联系展会组委会',
    tele: '010-84293538',
    titleRent: '总租金',

    rules: {
      name: '姓名不能为空',
      company: '单位名称不能为空',
      address: '单位地址不能为空',
      column11: '证件类型不能为空',
      column12: '证件号码不能为空',
      phone: '手机号码不能为空',
      phoneLength: '手机号码格式不合规，请重新输入',
      papersType: '请先选择证件类型',
      idcard: '身份证号码不符合规范，请重新输入',
      bootNum: '展位号不能为空',
      placeholder: '请先选择证件类型',
      email: '邮箱格式不合规，请重新输入',
      emailRequire: '邮箱不能为空',
    },
  },

  //下载中心
  downdCenter: {
    uploadTime: '上传时间',
    downd: '下载',
  },

  //联系我们
  connection: {
    committee: '组委会',
    title: '展览综合服务',
    title2: '会议服务',
    title3: '其他综合服务',
    title4: '展会负责人',
    serverContent: '服务内容',
    name: '中国煤炭工业国际技术咨询有限责任公司',
    address: '北京市东城区安外大街192号煤机大厦',
    mobile: '北京市东城区安定门外大街乙88号中煤大厦',
    principal: '各展馆负责人',
    // 第二行
    th2: 'E1 - E4 ',
    th2name: '王应朋',
    th2iphone: '18600660197',
    th2Telep: '010-64253061',
    th2serverContent:'展前、展中及展后需要咨询、解决及协调的事宜与服务',
    //第三行
    th3: 'w2  w4 ',
    th3name: '马　洁',
    th3iphone: '18600660196',
    th3Telep: '010-64222205',
    th3serverContent:'',

    //第四行
    th4: 'E5 - E6 - E7 室外A区域',
    th4name: '王军',
    th4iphone: '18600623265',
    th4Telep: '010-64212206',

    //第五行

    th5name: '贺子晨',
    th5iphone: '18910566893',
    th5Telep: '010-64212207',

    //第六行
    th6: '2023中国煤炭发展高峰论坛',
    th6serverContent: '论坛组织与协调',
    th6name: '史 玮',
    th6iphone: '18600660198',
    th6Telep: '010-64218081',


    //第七行
    th7: '技术交流会',
    th7serverContent: '技术交流会组织与协调',
    th7name: '成洁',
    th7iphone: '13810011312',
    th7Telep: '010-64212209',

    //其他综合服务第一条
    th8: '展会广告宣传',
    th8serverContent: '展会平面及现场广告预定',
    th8name: '李心宇',
    th8iphone: '13641233544',
    th8Telep: '010-64222208',

    //其他综合服务第二条
    th9: '展会会刊',
    th9serverContent: '会刊信息收集及编辑',
    th9name: '马洁/李心宇/张翔',
    th9iphone1: '18600660196',
    th9iphone2: '13641233544',
    th9Telep1: '010-64222205',
    th9Telep2: '010-64222208',
    
    //其他综合服务第三条
    th10: '参展商证',
    th10serverContent: '额外增加展商证件服务',
    th10name: '贺子晨',
    th10iphone: '18600623265',
    th10Telep: '010-64212207',

    //其他综合服务第三条
    th11: '展馆房间与会议室预订',
    th11serverContent: '预定展馆的房间和会议室登服务',
    th11name1: '史 玮 ',
    th11name2: '成洁',
    th11name3: '李心宇',
    th11iphone1: '18600660198',
    th11iphone2: '13810011312',
    th11Telep1: '010-64218081',
    th11Telep2: '010-64212207',

    //其他综合服务第三条
    th12: '现场签约活动',
    th12serverContent: '展会现场签约组织与协调',

    //其他综合服务第三条
    th13: '新闻媒体与发布',
    th13serverContent: '展会新闻媒体相关服务',

    //其他综合服务第三条
    th14: 'VR看展云服务',
    th14serverContent: '现在VR云看展点位增设',
    th14name: '王子辰',
    th14iphone: '16601369081',
    th14Telep: '010-64202216',

    //其他综合服务第三条
    th15: '展台视频备案',
    th15serverContent: '展商现场提供视频服务的需要在组委会备案',
    th15name: '李心宇',
    th15iphone: '16601369081',
    th15Telep: '010-64222208',

     //其他综合服务第三条
     th16: '负责人',
     th16serverContent: '统筹协调负责展会各项事宜',
     th16name: '张林',
     th16iphone: '15801077723',
     th16Telep: '010-64253002',

    //其他综合服务第三条
    th17name: '穆晓平',
    th17iphone: '1350117983',
    th17Telep: '010-64212203',

    conference: '会议联系人：',
    connePerson: '赵爱东  18600660195',
    principal1: '会议负责人',
    princiPers1: '张　林　15801077723',
    princiPers2: '穆晓平　13501179983',

    //海外扩招
    haiwai: {
      haiwaititle: '海外招展',
      overseasName: '海外企业（品牌）请联系',
      companyName: '汇显展览有限公司',
      hongkAddree: '香港地址',
      address: '香港筲箕湾南安街83号海安商业中心16楼A室',
      telePerson: '联系人',
      connPerson: '李笑群　00852-28815889',
      connPerson2: '尹小菲　010-84510286',
      beijingAddress: '北京地址',
      bjAddress: '北京市朝阳区新源里16号琨莎中心13层1座12A11',
    },

    //主场服务商
    zhuchang: {
      homeName: '主场服务商',
      compayName: '北京迈恒和泰展览有限公司',
      address: '地址',
      Address: '北京市朝阳区北三环东路6号中国国际展览中心院内1号馆4层362室',
      iphone: '电话',
      iphoneNum: '010-84602355/2358/ 2388 / 2369 / 2396',
      //第一行
      extensionNum: '分机号',
      telementNum: '馆长手机号',
      email: '馆长邮箱',

      //第二行
      th2: 'E1-E7及室外展区',
      th2Name: '王思思',
      th2exten: '8010',
      th2iphone: '13810672393',
      // //第三行
      // th3Name: '付　爽',
      // th3exten: '8002',
      // th3iphone: '13718373237',

      //第四行
      th4: 'W1-W4',
      th4Name: '朱泊岩',
      th4exten: '8013',
      th4iphone: '18612850217',

      // //第五行
      // th5Name: '张凯茜',
      // th5exten: '8008',
      // th5iphone: '15210833245',
    },

    //设备吊装服务商
    diaozhuang: {
      dzName: '设备吊装服务商',
      //  companyLabel:'单位名称',
      companyName: '中展运国际运输（北京）有限公司',
      companyAddress: '北京市朝阳区北三环东路6号中国国际展览中心1号馆5层539室',
      telephone: '电话',
      projectManager: '项目经理',
      manager: '董挥',
      telep: '010-8460 0605',
      phone: '13651049167',
      email: 'donghui@ciec.com.cn',
      principalTele:'各馆联系人及联系方式',

      //第二行
      th: 'E1/A区',
      thName: '李海龙',
      thIphone: '13716130731',

      //第三行
      th2: 'E2/E5',
      th2Name: '张毅',
      th2Iphone: '13716243234',

      //第四行
      th3: 'E3/E6',
      th3Name: '方建亮',
      th3Iphone: '13716243234',

       //第五行
       th4: 'E4/E7',
       th4Name: '曹立新',
       th4Iphone: '13910191741',

      //第六行
      th5: 'w1',
      th5Name: '宫蚬智',
      th5Iphone: '15110215320',

      //第七行
      th6: 'w2',
      th6Name: '周强',
      th6Iphone: '13718664700',

      //第八行
      th7: 'w3',
      th7Name: '梁子东',
      th7Iphone: '13911765767',

      //第九行
      th8: 'w4',
      th8Name: '崔立伟',
      th8Iphone: '13718968786',
    },

    //酒店接待服务商
    hotel: {
      hotelTitle: '酒店接待服务商',
      companyName: '北京时代龙马国际会议展览有限公司',
      telep: '010-64462841',
      email: 'times@sdlm.cn',
      emailTip:'识别二维码可订酒店',
      connectPer: '董傲　18612291377 （手机微信同号）',
    },
  },
  //联系我们 备份
  // connection: {
  //   committee: '组委会',
  //   title: '展览综合服务',
  //   name: '中国煤炭工业国际技术咨询有限责任公司',
  //   address: '北京市东城区安外大街192号煤机大厦',
  //   mobile: '北京市东城区安定门外大街乙88号中煤大厦',
  //   principal: '各展馆负责人',
  //   // 第二行
  //   th2: 'E1 E2 E5',
  //   th2name: '王应朋 先生',
  //   th2iphone: '18600660197',
  //   thTelep: '',
  //   //第三行
  //   th3name: '马　洁 女士',
  //   th3iphone: '18600660196',
  //   th3Telep: '',

  //   //第四行
  //   th4: 'E3 E4',
  //   th4name: '史　玮 女士',
  //   th4iphone: '18600660198',
  //   th4Telep: '',

  //   //第五行

  //   th5name: '王子辰 先生',
  //   th5iphone: '16601369081',
  //   th5Telep: '',

  //   //第六行
  //   th6: 'W1',
  //   th6name: '尹小菲 女士',
  //   th6iphone: '17310285580',
  //   th6Telep: '010-84510286',

  //   //第七行
  //   th7: 'W2',
  //   th7name: '王　涛 先生',
  //   th7iphone: '18600660178',
  //   th7Telep: '',

  //   //第八行
  //   th8: 'W3 W4',
  //   th8name: '杨　理 先生',
  //   th8iphone: '13911007430',
  //   th8Telep: '',
  //   //第九行
  //   th9name: '贺子晨 先生',
  //   th9iphone: '18600623265',
  //   th9Telep: '',

  //   conference: '会议联系人：',
  //   connePerson: '赵爱东  18600660195',
  //   principal1: '会议负责人',
  //   princiPers1: '张　林　15801077723',
  //   princiPers2: '穆晓平　13501179983',

  //   //海外扩招
  //   haiwai: {
  //     haiwaititle: '海外招展',
  //     overseasName: '海外企业（品牌）请联系',
  //     companyName: '汇显展览有限公司',
  //     hongkAddree: '香港地址',
  //     address: '香港筲箕湾南安街83号海安商业中心16楼A室',
  //     telePerson: '联系人',
  //     connPerson: '李笑群　00852-28815889',
  //     connPerson2: '尹小菲　010-84510286',
  //     beijingAddress: '北京地址',
  //     bjAddress: '北京市朝阳区新源里16号琨莎中心13层1座12A11',
  //   },

  //   //主场服务商
  //   zhuchang: {
  //     homeName: '主场服务商',
  //     compayName: '北京迈恒和泰展览有限公司',
  //     address: '地址',
  //     Address: '北京市朝阳区北三环东路6号中国国际展览中心院内1号馆4层362室',
  //     iphone: '电话',
  //     iphoneNum: '010-84602355/2358/ 2388 / 2369 / 2396',
  //     //第一行
  //     extensionNum: '分机号',
  //     telementNum: '馆长手机号',
  //     email: '馆长邮箱',

  //     //第二行
  //     th2: 'E1-E7及室外展区',
  //     th2Name: '王思思',
  //     th2exten: '8010',
  //     th2iphone: '13810672393',
  //     // //第三行
  //     // th3Name: '付　爽',
  //     // th3exten: '8002',
  //     // th3iphone: '13718373237',

  //     //第四行
  //     th4: 'W1-W4',
  //     th4Name: '朱泊岩',
  //     th4exten: '8013',
  //     th4iphone: '18612850217',

  //     // //第五行
  //     // th5Name: '张凯茜',
  //     // th5exten: '8008',
  //     // th5iphone: '15210833245',
  //   },

  //   //设备吊装服务商
  //   diaozhuang: {
  //     dzName: '设备吊装服务商',
  //     //  companyLabel:'单位名称',
  //     companyName: '中展运国际运输（北京）有限公司',
  //     companyAddress: '北京市朝阳区北三环东路6号中国国际展览中心1号馆5层539室',
  //     telephone: '电话',

  //     //第二行
  //     th: 'E1-E5及室外展区',
  //     thName: '董　挥',
  //     thTelet: '010-84600605',
  //     thIphone: '13651049167',

  //     //第三行
  //     th3: 'W1-W4',
  //     th3Name: '白　鹏',
  //     th3Telet: '010-84600605',
  //     th3Iphone: '13910015451',
  //   },

  //   //酒店接待服务商
  //   hotel: {
  //     hotelTitle: '酒店接待服务商',
  //     companyName: '北京时代龙马国际会议展览有限公司',

  //     connectPer: '王向云　18612291377 （手机微信同号）',
  //   },
  // },
  //修改密码
  editPassword: {
    passwordTitle: '修改密码',
    originPassword: '原始密码',
    newPassword: '新密码',
    confimPassword: '确认密码',
    placeholder: '请输入密码',
    placeholder1: '两次输入密码不一致',
  },

  //团体时间
  teamInvite: {
    teamTitle: '邀请说明',
    tishi1: '展会组委会将依据贵司所提供的拟邀请观众信息，以展会组委会的名义发送邀请函，如果贵司有团体邀请的意向观众名单信息，敬请申报。',
    tishi2: '',
    placeholder1: '请输入姓名/公司名',
    search: '搜索',
    addbuys: '新增买家',
    departement: '部门/职责',
    companyName: '公司',
    companyAddress: '公司地址',
    editbuy: '编辑买家信息',
    inforTishi: '信息提交失败',
    inforTishi2: '信息提交失败,请稍候重试',
    inforTishi3: '信息提交成功',
    inforTishi4: ' 团体邀请申请已提交至主办方审核,请注意关注审核结果;',
    idcart: '身份证',
    certificate: '军官证',
    passport: '护照',
    hk: '港澳通行证',
  },

  //微信邀请函
  wxInvite: {
    wx: '微信邀请',
    wxTitle: '微信邀请函',
    enInvite: '中文邀请函',
    comapanych: '公司logo',
    canguan: '参观咨询电话',
    imgTishi: '格式：jpg, png; 建议尺寸：600*240px; 大小：2M',
    uploadimg: '请上传图片',
    tishiIphone: '请输入咨询电话',
    uploadLogo: '上传logo',
    booth: '请选择展位号：',
  },
  //pdf邀请
  pdfInvite: {
    padfTitle: 'PDF邀请函',
    tishi1: '第二十届中国国际煤炭采矿技术交流',
    tishi2: '及设备展览会观众邀请函',
    tishi3: '下载PDF文件，邀请观众与您共同参加第二十届',
    tishi4: '中国国际煤炭采矿技术交流设备展览会',
    downd: '点击下载',
  },

  //邮件邀请
  emailInvite: {
    title: '北京中国国际展览中心（新馆）',
    time: '2023年10月25-28日',
    invite: '诚邀您莅临',
    exName: '第二十届中国国际煤炭采矿技术交流及设备展览会',
    address1: '北京·中国国际展览中心(新馆)',
    client: '尊敬的客户：',
    content: '我司将于10月25-28日在北京参展',
    content2: '。我们将在展会上全面展示新产品、新技术、新解决方案。作为我们的合作伙伴和重要客户，诚邀您莅临我司展位参观、洽谈！',
    timeLabel: '时间：',
    addressLabel: '地点：',
    line: '立即预约登记参观',
    aboutme: '关于我们',
    weProduct: '我的产品',
    weActive: '我的活动',
    content3:
      '由中国煤炭工业协会主办、中国中煤能源集团有限公司协办，中国煤炭工业国际技术咨询有限责任公司和汇显展览有限公司承办的第二十届中国国际煤炭采矿技术交流及设备展览会（China Coal & Mining Expo2023）将于2023年10月25-28日在北京中国国际展览中心（新馆）举办。本届展会以“智能引领未来、绿色共享发展”为主题，吸引了全球17个国家和地区的近1000家企业参展，展览面积13万平方米，12大主题展馆，展会规模创历届展会之最。国内外重点煤机装备企业悉数到场参展，本届展会将有众多参展企业携带近两年研发的产品、新装备、新技术参展。智能化主题展品将继续大放异彩，海外品牌参展企业热度持续升温。这必将是我国煤炭行业又一次的饕餮盛宴。展会还打造了线上会展——易展煤机网，已经吸引1000多家展商入驻，发布展品近6000件。展会还将引入VR看展，全景呈现展会盛况，打造永不落幕的线上展会。展会同期将举办2023中国煤炭发展高峰论坛和多场技术交流会活动，预计本届展会参观人次有望再次突破12万人。',
    content4: ' 行业盛会！不容错过！期待光临！',
    exhibitorList: '展商列表',
    exhibits: '展品列表',
    graph: '展位图',
    live: '直播大厅',
    under: '了解展会',

    exhitZixun: '参展咨询',
    person: '王应朋',

    inputEmail: ' 请输入观众E-mail地址',
    inviteTa: '邀请TA一起参加',
    content5: '邀请多个观众时，请每行填写一个邮箱，一次最多可邀请200人',
  },

  //footer
  footer: {
    title: '第二十届中国国际煤炭采矿技术交流及设备展览会组委会',
    linke: '快速链接',
    tishi1: '展览会微信公众号',
    tishi2: '请扫描二维码进行关注',
    // 展会官网添加内容
    titleTop: '第二十届',
    titleBottom: '中国国际煤炭采矿技术交流及设备展览会组委会',
    link: '快速链接',
    company: '汇显展览有限公司',
    weChatOfficialAccount: '展览会微信公众号',
    qrCodeAttention: '请扫描二维码进行关注',
    mobileQrCodeAttention: '请扫描二维码关注展览会微信公众号',
    copyright: '版权所有：中国煤炭工业国际技术咨询有限责任公司',
    technicalSupport: '技术支持：中煤信息技术(北京)有限公司',
    spareNumber1: '京公网安备11010102002548号',
    spareNumber2: '京ICP备09033595号-1',
    address: '北京市东城区安外大街乙88号中煤大厦',
    linkUrl: {
      viewcz: '我要参展',
      viewcg: '我要参观',
      zwt: '展位图',
      zhrc: '展会日程',
      hzZhanhui: '展会官网',
      mjlt: '煤机论坛',
    },
    unit: {
      title1: '主办单位',
      title2: '协办单位',
      title3: '承办单位',
      text1: '中国煤炭工业协会',
      text2: '中国中煤能源集团有限公司',
      text3: '中国煤炭工业国际技术咨询有限责任公司',
    },
    //结束

    linkeText: {
      linkeText1: '我要参展',
      linkeText2: '我要参观',
      linkeText3: '展位图',
      linkeText4: '展会日程',
      linkeText5: '展会官网',
      linkeText6: '煤机论坛',
    },
  },

  //所有项目的弹框英文信息 和message信息
  dialog: {
    //展商信息页面公司信息的内容
    message: '公司Logo·中文不能为空!',
    message1: '上传文件只能是 jpg、png格式',
    message2: '上传文件大小不能超过 10MB!',
    message3: '请上传图片格式的文件!',
    message4: '上传文件只能是 mp4、mov格式!',
    message5: '上传文件大小不能超过 100MB!',
    confirm: '是否替换已上传视频？',
    sureMess: '确认信息',
    sure: '确定',
    cancel: '取消',

    confirmDelete: '确认要删除吗？',
    attention: '注意!',
    deletSucce: '删除成功！',
    suncSort: '修改排序成功！',
    cancelDelet: '已取消删除',

    confirmSubmit: '确认要提交吗？',
    submitSuccess: '提交成功',

    //添加活动的弹框信息
    startTime: '活动开始时间不能为空!',
    endTime: '活动结束时间不能为空!',
    actiPict: '活动照片不能为空!',
    actTextEn: '活动简介·中文不能为空!',
    tishi1: '请选择活动类型',
    tishi2: '请输入活动名称·中文',
    tishi3: '开始时间不能为空',
    tishi4: '结束时间不能为空',
    tishi5: '请输入活动地点',
    tishi6: '请选择活动图片',
    tishi7: '请输入活动简介·中文',
    message6: '封面图片最大500kb',
    message7: '上传的文件不能大于2M',
    undeed: '审核通过',
    nounder: '审核未通过',
    undering: '审核中',

    //添加新闻

    message8: '请输入新闻标题',
    message9: '请输入摘要·中文',
    message10: '请输入新闻内容·中文',
    message11: '新闻内容·中文不能为空!',

    //上传宣传资料
    message12: '资料文件不能为空!',
    message13: '语言不能为空',
    message14: '资料名称不能为空',
    message15: '资料文件不能为空',

    //会刊信息
    message16: '提交会刊信息信息成功!',
    message17: '提交会刊信息信息失败!',
    message18: '请填写必填项!',

    //参展商证
    message19: '上传参展人员excel表成功!',
    message20: '请将红色提示修改后再提交',
    message21: '提交参展人员信息成功',
    message22: '身份证号验证失败,请重新输入身份证号!',
    message23: '修改参展人员成功!',
    message24: '删除参展人员成功!',
    message25: '新增参展人员成功!',
    message26: '新增参展人员失败',

    //团队邀请
    message27: '上传买家excel表格成功!',
    addbuy: '新增买家成功',
    bugceil: '新增买家失败',
    editbug: '修改买家信息成功',
    deletbug: '删除买家成功',
    message28: '当前提交信息为空！！',
    submit: '提交',
  },
  share: {
    friend: '分享到朋友圈',
    wechat: '分享到微信',
    link: '复制链接',
  },
  downloadMobile: {
    isDownload: '是否要下载',
    download: '下载',
  },
};
// {{ $t('exhiInformat.message') }}
